import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
export var parseBool = function parseBool(str) {
  return str === 'false' ? false : str === '0' ? false : !!str;
};
export var dataToObject = function dataToObject(data) {
  return data.reduce(function (a, c) {
    var _Object$assign;

    return Object.assign({}, a, (_Object$assign = {}, _Object$assign[c.key] = JSON.parse(c.data), _Object$assign));
  }, {});
};
export var enumerate = function enumerate() {
  var obj = {};

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  args.forEach(function (arg, i) {
    obj[obj[arg] = i] = arg;
  });
  return obj;
};
export function parseJSON(value, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? {} : _ref$defaultValue,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? "Couldn't parse JSON" : _ref$errorMessage;

  var result;

  try {
    result = value ? JSON.parse(value) : defaultValue;
  } catch (e) {
    console.log(errorMessage);
    result = defaultValue;
  }

  return result;
}
export var getViewportDimensions = function getViewportDimensions() {
  if (typeof window === 'undefined') return {
    height: null,
    width: null
  };
  return {
    height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
    width: Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
  };
};